import Masthead from './components/Masthead';
import Hero from './components/Hero';
import TrustEntry from './components/TrustEntry';
import VerifySteps from './components/VerifySteps';
import CompareList from './components/CompareList';
import ReadingList from './components/ReadingList';
import Discussion from './components/Discussion';
import SubscribeForm from './components/SubscribeForm';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Masthead />
      <main>
        <Hero />
        <TrustEntry />
        <VerifySteps />
        <CompareList />
        <ReadingList />
        <Discussion />
        <SubscribeForm />
      </main>
      <SiteFooter />
    </div>
  );
}